// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"ba8841bf","453":"825386d9","967":"11f666ab"}[chunkId] + ".chunk.js";
};